import { render } from "./AdminUserRegister.vue?vue&type=template&id=5f016b09&scoped=true"
import script from "./AdminUserRegister.vue?vue&type=script&lang=js"
export * from "./AdminUserRegister.vue?vue&type=script&lang=js"

import "./AdminUserRegister.vue?vue&type=style&index=0&id=5f016b09&scoped=true&lang=css"

import exportComponent from "/var/www/adminold.quickup.uk/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5f016b09"]])

export default __exports__